module.exports = __webpack_public_path__ + "media/puzzle5_5.0a601ad0.mp3";